// One upcoming market line inside its event card: market name, flat
// sparkline (static pre-match quote — single point renders as a level line),
// current oracle price. Suspended markets get a chip next to the name and a
// grayed price. Kick-off countdown is event-level → card header.

import type { MarketSnapshot } from '../feed';
import { Sparkline } from './sparkline';
import { SuspendedChip } from './status-ribbon';

export function UpcomingMarketLine({ market }: { market: MarketSnapshot }) {
  const suspended = market.status === 'suspended';
  return (
    <div className="flex items-center gap-3 py-2">
      <p className="flex min-w-0 flex-1 items-center gap-1.5 truncate text-xs opacity-80">
        <span className="truncate">{market.displayName || market.name}</span>
        {suspended && <SuspendedChip />}
      </p>
      <Sparkline points={market.history} direction={market.priceDirection} />
      <span
        className={`w-16 text-right text-sm font-semibold tabular-nums ${suspended ? 'opacity-40' : ''}`}
      >
        {market.price === null ? '—' : market.price.toFixed(2)}
      </span>
    </div>
  );
}
